import axios, { type CreateAxiosDefaults } from 'axios';
import type { FormData } from '../types/general';
const API_URL = import.meta.env.VITE_API_URL || window.location.origin;

export async function getXCSRFToken() {
  return await fetch(`${API_URL}/session/token`, { credentials: 'include' }).then((response) => response.json());
}

const config: CreateAxiosDefaults<any> = {
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
};
export const Axios = axios.create(config);

// Get token for POST requests
let token = '';
if (import.meta.env.MODE === 'production') {
  Axios.get('/session/token').then((response) => {
    token = response.data;
    window.localStorage.setItem('token', token);
  });
}

Axios.interceptors.request.use((config) => {
  if (!token) return config;
  if (config.method === 'post' || config.method === 'delete') {
    config.headers['X-CSRF-Token'] = token;
  }
  return config;
});

export async function getRecaptchaSettings() {
  const url = '/recaptcha-setting';
  try {
    const { data } = await Axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getSettings() {
  const url = '/api/programs';
  try {
    const { data } = await Axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function submitFormData(formData: FormData) {
  const url = '/api/create-submission';
  try {
    return await Axios.post(url, formData);
  } catch (error) {
    console.log(error);
    return null;
  }
}
